import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import IntakeHeader from "@/components/intake/IntakeHeader";

export default function Welcome() {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const devMode = params.get("dev") === "1";

    const begin = async () => {
        try {
            const { data } = await api.post("/intake/draft", {});
            localStorage.setItem("aurum_resume_token", data.resume_token);
            const qs = devMode ? `&dev=1` : "";
            navigate(`/intake?token=${data.resume_token}${qs}`);
        } catch {
            toast.error("Could not start application. Please try again.");
        }
    };

    return (
        <div className="intake-shell flex flex-col" data-testid="welcome-page">
            <IntakeHeader currentStep={1} totalSteps={6} />

            <main className="flex-1 flex items-center justify-center px-6 py-12">
                <div className="intake-card w-full max-w-4xl px-8 md:px-14 py-16 md:py-24 text-center animate-fade-up">
                    <div className="step-eyebrow mb-6" data-testid="welcome-eyebrow">STEP 1</div>
                    <h1
                        className="font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.1] tracking-tight max-w-3xl mx-auto"
                        data-testid="welcome-heading"
                    >
                        Welcome — Your Credit Journey Starts Now
                    </h1>
                    <p className="mt-8 text-white/55 uppercase tracking-[0.28em] text-xs sm:text-sm font-sans">
                        Secure&nbsp;·&nbsp;Private&nbsp;·&nbsp;Step-By-Step
                    </p>
                    <div className="mt-14 flex items-center justify-center">
                        <div className="begin-halo">
                            <button
                                onClick={begin}
                                className="btn-gold px-14 py-4 text-sm sm:text-base uppercase tracking-[0.25em]"
                                data-testid="welcome-begin-btn"
                            >
                                Begin
                            </button>
                        </div>
                    </div>
                </div>
            </main>

            <footer className="px-6 md:px-12 py-6 text-center text-xs text-white/40">
                © {new Date().getFullYear()} BSG Investments · All information is encrypted in transit.
            </footer>
        </div>
    );
}
